import SetIsActive from '@/common/components/SetIsActive'
import useMutationUpdateCommission from '@/modules/promotion/api/hooks/useMutateUpdateCommission'
import { CommissionCashbackQueryKeys } from '@/modules/promotion/keys'
import { GetCommissionCashbackResponseData } from '@/modules/promotion/type'
import { useQueryClient } from '@tanstack/react-query'

interface IsActiveCommissionProps {
	row: GetCommissionCashbackResponseData
}

export function IsActiveCommission({ row }: IsActiveCommissionProps) {
	const { mutateAsync: updateCommission } = useMutationUpdateCommission()
	const queryClient = useQueryClient()

	const handleMutate = async (value: boolean) => {
		await updateCommission(
			{
				id: row.id,
				payload: {
					isActive: value,
				},
			},
			{
				onSuccess: () => {
					queryClient.invalidateQueries({
						queryKey: [CommissionCashbackQueryKeys.GetCommissionCashbackList],
					})
				},
			},
		)
	}

	return <SetIsActive defaultChecked={row.isActive} onMutate={handleMutate} />
}
